import { Button } from '@cannect/new-components/atoms'
import { Modal } from 'components/Modal'
import { useState } from 'react'
import { FiCheck, FiCopy } from 'react-icons/fi'
import { RecipeDocument } from '..'
import * as Style from './styles'

type DocumentsListModalProps = {
  isOpen: boolean
  documents: RecipeDocument[]
  onRequestClose: () => void
}

export default function DocumentsListModal({ isOpen, documents, onRequestClose }: DocumentsListModalProps) {
  const [copiedCode, setCopiedCode] = useState('')

  function handleOpenDocument(url: string) {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  async function handleCopyVerificationCode(code: string) {
    await navigator.clipboard.writeText(code)
    setCopiedCode(code)
    setTimeout(() => setCopiedCode(''), 2000)
  }

  return (
    <Modal isOpened={isOpen} onRequestClose={onRequestClose} overlayColor="rgba(116, 131, 81, 0.31)">
      <Style.DocumentsModalContainer>
        <h1>Seus documentos</h1>
        <p>
          Sua emissão foi dividida nos documentos abaixo. <br />
          Baixe cada um separadamente.
        </p>
        <Style.DocumentsList>
          {documents.map((document) => (
            <Style.DocumentCard key={document.token}>
              <Style.DocumentInfo>
                <span>{document.label}</span>
                {document.type === 'rce' && document.verification_code && (
                  <>
                    <Style.VerificationCode>
                      Código de verificação: <b>{document.verification_code}</b>
                      <button
                        type="button"
                        onClick={() => handleCopyVerificationCode(document.verification_code as string)}>
                        {copiedCode === document.verification_code ? <FiCheck size={16} /> : <FiCopy size={16} />}
                      </button>
                    </Style.VerificationCode>
                    <Style.VerificationNote>
                      A farmácia valida a autenticidade em{' '}
                      <a href="https://validar.iti.gov.br" target="_blank" rel="noreferrer">
                        validar.iti.gov.br
                      </a>
                    </Style.VerificationNote>
                  </>
                )}
              </Style.DocumentInfo>
              <Button size="md" onClick={() => handleOpenDocument(document.url)}>
                Baixar
              </Button>
            </Style.DocumentCard>
          ))}
        </Style.DocumentsList>
      </Style.DocumentsModalContainer>
    </Modal>
  )
}
